<button type="button" class="ia-topbar-action" aria-label="Search products" title="Search products" (click)="open(searchDialog)">
  <i class="flaticon2-search-1" aria-hidden="true"></i>
</button>
<ng-template #searchDialog>
  <app-dialog-header [titleId]="titleId" description="Enter an exact SKU to open its details." (dismissed)="dismiss()">Find a product</app-dialog-header>
  <form (submit)="$event.preventDefault(); search()" [attr.aria-busy]="searching">
    <div class="modal-body">
      <label [for]="inputId" class="form-label">SKU</label>
      <input ngbAutofocus type="text" class="form-control" [id]="inputId" [formControl]="sku" autocomplete="off" aria-required="true"
        placeholder="Enter SKU" [readOnly]="searching" [class.is-invalid]="invalidSku" [attr.aria-invalid]="invalidSku"
        [attr.aria-describedby]="errorMessage ? inputId + '-error' : null" (input)="clearError()">
      <p *ngIf="errorMessage" [id]="inputId + '-error'" class="text-danger mt-2 mb-0" role="alert">{{ errorMessage }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="dismiss()">Cancel</button>
      <button type="submit" class="btn btn-primary" [disabled]="searching || !sku.value.trim()">{{ searching ? 'Searching…' : 'Search' }}</button>
    </div>
  </form>
</ng-template>
